module.exports = __webpack_public_path__ + "7362274850a1dd44a5cf296aec0328b5.png";